#import "@/apollo/fragments/MasterTemplate.gql"

query ClientMasterTemplate($clientId: ID!) {
    masterTemplatesByClient(clientId: $clientId) {
        ...MasterTemplate
        psdThumbnail
    }
}
